import type { ISVG } from './index';

/**
 * A message sheet with a dashed placeholder line — "written once, filled in each time". Sidebar
 * nav icon for Message Templates.
 */
export const MessageTemplateSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		<rect
			x='4'
			y='3'
			width='16'
			height='18'
			rx='1'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		<path
			d='M8 8h8M8 12h5'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		<path
			d='M8 16h8'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeDasharray='1.5 2'
		/>
	</svg>
);
